import { formatMoney } from "@/lib/api";
import { Lock } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export function PriceDisplay({ msrp, member, showMember, compact = false, testId = "price-display" }) {
  if (showMember) {
    return (
      <div className={compact ? "text-right" : ""} data-testid={`${testId}-member`}>
        <div className="font-mono text-xs text-[#52525B] line-through">{formatMoney(msrp)} MSRP</div>
        <div className="font-mono font-bold text-2xl text-[#00D4FF]">{formatMoney(member)}</div>
        <div className="font-mono text-[10px] text-[#00D4FF] tracking-widest uppercase">Member Price</div>
      </div>
    );
  }
  return (
    <div className={compact ? "text-right" : ""} data-testid={`${testId}-msrp`}>
      <div className="font-mono font-bold text-2xl text-white">{formatMoney(msrp)}</div>
      <div className="font-mono text-[10px] text-[#9CA3AF] tracking-widest uppercase">MSRP</div>
      <Link to="/register" className="inline-flex items-center gap-1 text-[10px] font-mono text-[#00D4FF] tracking-widest uppercase mt-1 hover:underline">
        <Lock size={10} weight="bold" /> Member Price Locked
      </Link>
    </div>
  );
}
